<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <h2>به سامانه مدیریت پولاد پیچ‌کار خوش آمدید!</h2>
    <h3>
      نقش شما در سامانه {{ role }} است. میتوانید از منوی سمت راست به صفحات
      اختصاصی تعبیه شده برای خودتان دسترسی داشته باشید.
    </h3>
    <h3>
      در صورت وجود هرگونه سوال میتوانید با دفتر مرکزی یا پشتیبانی فنی تماس
      بگیرید.
    </h3>
    <h4>{{ roleType }}</h4>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";


export default {
  components: {},
  data: function () {
    return {
      guide: false,
      roles: {
        Manager: "مدیر",
        ceo: "مدیرعامل",
        secretary: "منشی",
        trade: "کارشناس بازرگانی",
        tradeIntern: "کارآموز بازرگانی",
        tradeHead: "کارشناس فنی",
        queryOrganizer: "بازرس سفارشات",
        accountant: "حسابدار",
        salesManager: "مدیر فروش",
        factory: "مدیر کارخانه",
        factoryTechnical: "مسئول فنی کارخانه",
        qa: "QA & DCC",
        qc: "مدیر کنترل کیفیت و آزمایشگاه",
        qcAgent: "کنترل کیفی",
        qcDocument: "سرتیفیکیت",
        factoryPacking: "مسئول پکینگ",
        production: "مدیر خط تولید",
        delivery: "دلیوری",
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
        warehouse: "مسئول کل انبار",
        productsWarehouse: "مسئول انبار محصولات",
        materialsWarehouse: "مسئول انبار مواد اولیه",
        toolsWarehouse: "مسئول انبار ملزومات",
        shop: "مسئول فروشگاه",
      },
      factoryRoles: {
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
      },
      role: "",
      roleName: "",
      roleType: "",
    };
  },

  methods: {},

  mounted() {
    this.roleName = window.localStorage.getItem("role");
    try {
      if (this.roles[this.roleName]) {
        this.role = this.roles[this.roleName];
        if (this.role == "factory")
          this.$router.push("/" + this.roleName + "/productionDashboard");
        else if (this.factoryRoles[this.roleName])
          this.$router.push("/" + this.roleName + "/productionTasks");
        else this.roleType = "اداری";
      } else {
        this.role = "تعریف نشده";
      }
    } catch (error) {
      this.role = "تعریف نشده";
    }
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

